export function commaSeparatedString(...values: any){
    const validValues = values.filter((value: any) => value);
    return validValues.join(","); 
}

export function getCommaSeparatedString(tagType: string, value: any) {

    if(tagType === 'Property'){
        let element = [];
        const title = value.split(',');
        for (let i = 0; i < title.length; i++) {
            if (title[i] && title[i] != " ") {
                element.push(title[i]);
            }
        }
        const joinedElements = element.join(',');
        return joinedElements;
    }else{
        return value;
    }

}